<template>
    <div>
        <Headers :windowWidth="windowWidth" />
        <div class="t1">
            <el-button class="save back" @click="gotoEdit">Edit</el-button>
        </div>
        <div class="createAccount_wrap">
            <div class="title">{{from.type == '4' ? 'Company' : 'Agency'}} Information</div>

                <el-row type="flex" justify="center">
                    <el-col :span="12" >
                        <el-row :gutter="280">
                            <el-col :span="12">
                                <div class="txt1">Company Name</div>
                                <div class="txt2">{{from.companyName}}</div>
                            </el-col>
                            <el-col :span="12">
                                <div class="txt1">UEN</div>
                                <div class="txt2">{{from.uen}}</div>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="center">
                    <el-col :span="12">
                        <div class="h3">Contact Person(s) Details</div>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="center">
                    <el-col :span="12" >
                        <el-row :gutter="280">
                            <el-col :span="12">
                                <div class="txt1">First Name</div>
                                <div class="txt2">{{from.firstName}}</div>
                            </el-col>
                            <el-col :span="12">
                                <div class="txt1">Last Name</div>
                                <div class="txt2">{{from.lastName}}</div>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="center" class="mg_t_40">
                    <el-col :span="12" >
                        <el-row :gutter="280">
                            <el-col :span="12">
                                <div class="txt1">User Name</div>
                                <div class="txt2">{{from.username}}</div>
                            </el-col>
                            <el-col :span="12">
                                <div class="txt1">Phone Number</div>
                                <div class="txt2">{{from.mobile}}</div>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="center" class="mg_t_40">
                    <el-col :span="12" >
                        <el-row :gutter="280">
                            <el-col :span="12">
                                <div class="txt1">Email Address</div>
                                <div class="txt2">{{from.email}}</div>
                            </el-col>
                            <el-col :span="12">
                                <div class="txt1">Facility address</div>
                                <div class="txt2">{{from.facilityAddress}}</div>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="center" class="mg_t_40">
                    <el-col :span="12" >
                        <el-row :gutter="280">
                            <el-col :span="12">
                                <div class="txt1">Facility name</div>
                                <div class="txt2">{{from.facilityName}}</div>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="center" class="mg_t_40">
                    <el-col :span="12" >
                        <el-row :gutter="280">
                            <el-col>
                                <div class="txt1">User Role(s)</div>
                                <div class="tet_box">
                                    <div>
                                        <div class="tet_1">Agency</div>
                                        <div class="tet_2">{{from.agencyRoles}}</div>
                                    </div>
                                    <div>
                                        <div class="tet_1">Company</div>
                                        <div class="tet_2">{{from.companyRoles}}</div>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="center" class="mg_t_40">
                    <el-col :span="12" >
                        <el-row :gutter="280">
                            <el-col :span="12">
                                <div class="txt1">Password</div>
                                <div class="txt2">******</div>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="center">
                    <el-col :span="12" class="flex_btn">
                        <el-button class="save back" @click="back">{{$t('createAccount.Back')}}</el-button>
                    </el-col>
                </el-row>


            
            
        </div>
    </div>
</template>
<script>
import Headers from "@/components/header/index.vue";
import carbon from "@/api/carbon.js";
export default {
    components: { Headers },
    data(){
        return {
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            status:false,
            checkList: [],
            id:'',
            from:{},
        }
    },
    mounted() {
        if(this.$route.query.id){
            this.id = this.$route.query.id
        }else{
            this.id = JSON.parse(sessionStorage.getItem('login')).id
        }
        this.getuserinfo()
        let that = this;
        window.onresize = () => {
        return (() => {
            window.fullWidth = document.documentElement.clientWidth;
            (that.windowWidth = document.documentElement.clientWidth), //实时屏幕宽度
            (that.windowHeight = window.fullHeight); // 高
        })();
        };
    },
    methods:{
        save(){
            this.$router.push('/accountDetail')
        },
        back(){
            this.$router.go(-1)
        },
        getuserinfo(){
            let params = {
                id:this.id,
            }
            carbon.getuserinfo((res) => {
                if(res.code == 200){
                    this.from = res.data
                }
            },params);
        },
        gotoEdit(){
            this.$router.push({
                path:'/createAccount',
                query:{
                    id:this.id
                }
            })
        },
        changeAgency(){
            console.log(this.checkList)
        },
        changeCompany(){
            console.log(this.checkList)
        },
    }

}
</script>
<style lang="scss" scoped>
.t1{
    font-size: 40px;
    font-family: Arial-BoldMT, Arial;
    font-weight: 600;
    color: #1E1E1E;
    line-height: 45px;
    margin: 48px auto;
    display: flex;
    justify-content: flex-end;
    width: 1534px;
}
.mg_t_40{
    margin-top: 40px;
}
.txt1{
    font-size: 16px;
    font-family: ArialMT;
    color: #626262;
    line-height: 18px;
    margin-bottom: 20px;
}
.tet_box{
    padding: 30px 40px;
    background: #FFFFFF;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    .tet_1{
        font-size: 16px;
        font-family: Arial-BoldMT, Arial;
        font-weight: bold;
        color: #1E1E1E;
        line-height: 18px;
    }
    .tet_2{
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #00142A;
        line-height: 20px;
        margin: 10px 0;
    }
}
.txt2{
    font-size: 16px;
    font-family: Arial-BoldMT, Arial;
    font-weight: bold;
    color: #1E1E1E;
    line-height: 18px;
}
.flex_i{
    display: flex;
    align-items: flex-start;
    font-size: 14px;
    font-family: ArialMT;
    color: rgba(0,20,42,0.5);
    line-height: 20px;
    margin-top: 12px;
    .l{
        margin-right: 15px;
    }
    .r{
        text-align: justify;
    }
}
.createAccount_wrap{
    width: 1440px;
    background: #F8F9FA;
    margin: 0 auto;
    margin-top: 50px;
    margin-bottom: 50px;
    border-radius: 20px;
    padding: 74px 42px 105px 52px;
    .title{
        font-size: 40px;
        font-family: Arial-BoldMT, Arial;
        font-weight: 600;
        text-align: center;
        color: #158869;
        line-height: 45px;
        margin-bottom: 50px;
    }
    .checkbox{
        height: 164px;
        background: #FFFFFF;
        border-radius: 4px;
        margin-top: 60px;
        padding: 20px;
    }
    .save{
        width: 125px;
        height: 44px;
        background: #158869;
        border-radius: 4px;
        font-size: 16px;
        font-family: ArialMT;
        color: #FFFFFF;
    }
    .back{
        background-color: #F8F9FA;
        border-color: #97A5B7;
        color: #97A5B7;
    }
}
.ch_box{
    padding: 32px 40px;
    background: #FFFFFF;
    border-radius: 8px;
    margin-bottom: 20px;
    .ch_t{
        font-size: 16px;
        font-family: Arial-BoldMT, Arial;
        font-weight: 600;
        color: #1E1E1E;
        line-height: 18px;
        margin-bottom: 12px;
    }
    .mg_t_40{
        margin-top: 40px;
    }
}
.flex_btn{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 80px;
}
.c_tl{
    font-size: 14px;
    font-family: Arial-BoldMT, Arial;
    font-weight: bold;
    color: #21212B;
}
.h3{
    font-size: 30px;
    font-family: Arial-BoldMT, Arial;
    font-weight: 600;
    color: rgba(30,30,30,0.8);
    line-height: 34px;
    margin: 90px 0 50px 0;
}
::v-deep .el-switch__label.is-active{
    font-size: 14px;
    font-family: Arial-BoldMT, Arial;
    font-weight: bold;
    color: #21212B;
}
::v-deep .el-switch__label{
    font-weight: bold;
    font-size: 14px;
    font-family: Arial-BoldMT, Arial;
}
::v-deep .el-form-item__label{
    font-size: 14px;
    font-family: Arial-BoldMT, Arial;
    font-weight: bold;
    color: #21212B;
}
::v-deep .el-checkbox__label{
    font-size: 14px;
    font-family: ArialMT;
    color: #626262;
}
::v-deep .el-checkbox__inner{
    width: 20px;
    height: 20px;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner{
    background-color: #158869;
    border-color:#158869;
}
::v-deep .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #158869;
    font-size: 14px;
    font-family: ArialMT;
}
::v-deep .el-checkbox__inner::after{
    top: 17%;
    left: 42%;
}
</style>